// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-header {
  display: flex;
  direction: rtl;
  justify-content: space-around;
  margin-top: 20px;
}

mat-label {
  font-size: small;
}

mat-option {
  font-size: small;
}

input#mat-input-0 {
  font-size: small;
}

input#mat-input-1 {
  font-size: small;
}

.parent-container {
  display: flex;
  direction: rtl;
  margin-top: 30px;
  justify-content: space-around;
}

.container {
  width: 100px;
}

.container-type {
  margin-top: 30px;
}

.isDocument {
  margin-left: 10px;
}

.text-error {
  color: red;
  direction: rtl;
  font-size: small;
  margin-right: 10px;
}

.butn-next {
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/quote-request/quote-logistics-service-info/quote-logistics-service-info.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/quote-request/quote-logistics-service-info/quote-logistics-service-info.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADCA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;ACEJ;;ADCA;EACI,YAAA;ACEJ;;ADAA;EACI,gBAAA;ACGJ;;ADDA;EACI,iBAAA;ACIJ;;ADFA;EACI,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACKJ;;ADHA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;ACMJ","sourcesContent":[".parent-header {\r\n    display: flex;\r\n    direction: rtl;\r\n    justify-content: space-around;\r\n    margin-top: 20px;\r\n}\r\n\r\nmat-label {\r\n    font-size: small;\r\n}\r\n\r\nmat-option {\r\n    font-size: small;\r\n}\r\n\r\ninput#mat-input-0 {\r\n    font-size: small;\r\n}\r\n\r\ninput#mat-input-1 {\r\n    font-size: small;\r\n}\r\n.parent-container{\r\n    display: flex;\r\n    direction: rtl;\r\n    margin-top: 30px;\r\n    justify-content: space-around;\r\n\r\n}\r\n.container{\r\n    width: 100px;\r\n}\r\n.container-type{\r\n    margin-top: 30px;\r\n}\r\n.isDocument {\r\n    margin-left: 10px;\r\n}\r\n.text-error{\r\n    color: red;\r\n    direction: rtl;\r\n    font-size: small;\r\n    margin-right: 10px;\r\n}\r\n.butn-next{\r\n    margin-left: 10px;\r\n    margin-bottom: 10px;\r\n    margin-top: 20px;\r\n}",".parent-header {\n  display: flex;\n  direction: rtl;\n  justify-content: space-around;\n  margin-top: 20px;\n}\n\nmat-label {\n  font-size: small;\n}\n\nmat-option {\n  font-size: small;\n}\n\ninput#mat-input-0 {\n  font-size: small;\n}\n\ninput#mat-input-1 {\n  font-size: small;\n}\n\n.parent-container {\n  display: flex;\n  direction: rtl;\n  margin-top: 30px;\n  justify-content: space-around;\n}\n\n.container {\n  width: 100px;\n}\n\n.container-type {\n  margin-top: 30px;\n}\n\n.isDocument {\n  margin-left: 10px;\n}\n\n.text-error {\n  color: red;\n  direction: rtl;\n  font-size: small;\n  margin-right: 10px;\n}\n\n.butn-next {\n  margin-left: 10px;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
